import { create } from 'zustand';

interface DownloadReasonStore {
  resolve: ((reason: string | null) => void) | null;
  open: (resolve: (reason: string | null) => void) => void;
  close: (reason: string | null) => void;
}

export const useDownloadReasonStore = create<DownloadReasonStore>((set, get) => ({
  resolve: null,
  open: (resolve) => set({ resolve }),
  close: (reason) => {
    get().resolve?.(reason);
    set({ resolve: null });
  },
}));

// 개인정보가 담긴 엑셀을 받기 전에 사유를 입력받는다(ISMS). 취소하면 null
export const requestDownloadReason = () =>
  new Promise<string | null>((resolve) => useDownloadReasonStore.getState().open(resolve));

export const withReasonQuery = (path: string, reason: string) =>
  `${path}${path.includes('?') ? '&' : '?'}reason=${encodeURIComponent(reason)}`;
